module.exports = __webpack_public_path__ + "img/loader.1da8b4c8.gif";